import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cardTight, sectionTitle, textMeta } from '../../uiStyles';

type GradeStepHeaderProps = {
  label: string;
  title: string;
  courseName?: string;
  assignmentTitle?: string;
  chips?: ReactNode;
};

export function GradeStepHeader({
  label,
  title,
  courseName,
  assignmentTitle,
  chips,
}: GradeStepHeaderProps): ReactNode {
  const { t } = useTranslation();
  const contextLine =
    (courseName || t('grade.stepHeader.noCourse')) +
    ' · ' +
    (assignmentTitle || t('grade.stepHeader.noAssignment'));
  return (
    <section className={cardTight}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <p className={sectionTitle}>{label}</p>
          <h2 className="mt-1 text-sm font-black text-slate-900 dark:text-slate-100">{title}</h2>
          <p className={`mt-1 ${textMeta}`}>{contextLine}</p>
        </div>
        {chips ? <div className="flex flex-wrap items-center gap-1.5">{chips}</div> : null}
      </div>
    </section>
  );
}
